import { MatTooltipDefaultOptions } from '@angular/material/tooltip';

// Set default CMS options for matTooltip delay
export const cmsMatTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 1500, // Delay time in ms before show tooltip
  hideDelay: 500,
  touchendHideDelay: 1000,
};
